export enum PresentationType {
  STANDARD = 0, // A presentation that interacts with the whole map but isn't associates with Lessons
  LESSON = 1,
  DEPRECATED_MODEL_ANSWER = 2, // Presentations as Model answers are no longer supported (but a few will still exist)
}
